export const cart = {
    title: 'Carrinho',
    empty: 'Seu carrinho está vazio',
    emptyDescription: 'Adicione produtos ao carrinho para continuar',
    continueShopping: 'Continuar comprando',
    checkout: 'Falar com vendedor',
    items: 'itens',
    item: 'item',
    removeItem: 'Remover item',
    updateQuantity: 'Atualizar quantidade',
    decreaseQuantity: 'Diminuir quantidade',
    increaseQuantity: 'Aumentar quantidade',
    close: 'Fechar carrinho',
    subtotal: 'Subtotal',
    shipping: 'Frete',
    discount: 'Desconto',
    total: 'Total',
    estimatedShipping: 'Frete estimado',
    freeShipping: 'Frete grátis',
    minForFreeShipping: 'Faltam {{amount}} para frete grátis',
};
//# sourceMappingURL=cart.js.map